export const DS_PALETTE_ITEM_CLASSES = {
  Base: "ds-palette-item",
} as const;
